/**
 * 判断是否为有限数
 * @return {Boolean}
 */
import isNumber from './is-number';
export default function (value) {
  return isNumber(value) && isFinite(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-finite.js
// module id = 85
// module chunks = 0